<template>
  <el-dialog
    top="15vh"
    class="series-edit__dialog"
    :title="row.id ? $t('Common.edit') : $t('Common.create')"
    width="600px"
    :close-on-click-modal="false"
    :before-close="close"
    :visible.sync="visible"
  >
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="auto"
      size="small"
      label-suffix=": "
    >
      <el-form-item :label="$t('Fota.firmwareName')" prop="name">
        <el-input
          v-model.trim="form.name"
          :placeholder="$t('Common.maxLengthTips16')"
          :maxlength="16"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('Fota.firmwareModel')" prop="productModel">
        <el-input
          v-model.trim="form.productModel"
          :placeholder="$t('Fota.firmwareModel')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('Fota.firmwareType')" prop="type">
        <el-radio-group v-model="form.type" :disabled="row.id">
          <el-radio label="SINGLE"> {{ $t('Fota.singleFirm') }} </el-radio>
          <el-radio label="DOUBLE"> {{ $t('Fota.doubleFirm') }} </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$t('Device.productName')" prop="productKey">
        <Select
          :disabled="row.id && row.deviceCount !== 0"
          :options="productList"
          v-model="form.productKey"
          :placeholder="$t('Device.productName')"
        >
        </Select>
      </el-form-item>
      <!--      <el-form-item :label="$t('Fota.hardwareModel')" prop="hardwareModel">-->
      <!--        <el-input-->
      <!--          v-model.trim="form.hardwareModel"-->
      <!--          :placeholder="$t('Fota.hardwareModel')"-->
      <!--        ></el-input>-->
      <!--      </el-form-item>-->
      <el-form-item :label="$t('Fota.remark')" prop="remark">
        <el-input
          type="textarea"
          :rows="3"
          maxlength="100"
          show-word-limit
          v-model.trim="form.remark"
          resize="none"
          :placeholder="$t('Fota.remark')"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="edit-footer">
      <el-button size="small" @click="close">{{ $t('Common.cancel') }}</el-button>
      <el-button type="primary" size="small" @click="save" :loading="loading">{{
        $t('Common.save')
      }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Select from '@/components/CommonForm/Select'
export default {
  components: {
    Select
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object
    }
  },
  data() {
    return {
      form: {
        type: 'SINGLE'
      },
      productList: [],
      rules: {
        name: [{ required: true, message: this.$t('Fota.firmwareName'), trigger: 'blur' }],
        productModel: [{ required: true, message: this.$t('Fota.firmwareModel'), trigger: 'blur' }],
        productKey: [{ required: true, message: this.$t('Device.productName'), trigger: 'change' }],
        type: [{ required: true, message: this.$t('Fota.firmwareType'), trigger: 'change' }]
        // hardwareModel: [{ required: true, message: this.$t('Fota.hardwareModel'), trigger: 'blur' }]
      },
      loading: false
    }
  },
  created() {
    this.getProductIds()
    if (this.row.id) {
      let params = {
        id: this.row.id
      }
      this.$ajax.get(this.$api.fota.firmware_detail, params).then((res) => {
        this.form = res.data
      })
    }
  },
  methods: {
    //获取产品下拉框列表
    getProductIds() {
      this.$ajax.get(this.$api.product.product_select, { status: 'ENABLE' }).then((res) => {
        this.productList = res.data
      })
    },
    close() {
      this.$emit('update:visible', false)
    },
    checkForm() {
      let pass
      this.$refs.form.validate((valid) => {
        pass = valid
      })
      return pass
    },
    save() {
      if (!this.checkForm()) return
      this.loading = true
      let params = {
        id: this.row.id,
        name: this.form.name,
        productModel: this.form.productModel,
        productKey: this.form.productKey,
        type: this.form.type,
        // hardwareModel: this.form.hardwareModel,
        remark: this.form.remark
      }
      let api = this.row.id ? this.$api.fota.firmware_update : this.$api.fota.firmware_insert
      this.$ajax
        .post(api, params)
        .then(() => {
          this.$message.success(
            `${this.row.id ? this.$t('Common.editSuccess') : this.$t('Common.createSuccess')}`
          )
          this.close()
          this.$emit('refresh')
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.series-edit__dialog {
  /deep/.el-dialog__body {
    padding-left: 40px;
  }
}
</style>
